<template>
  <div class="page-container" id="ILPWMS">
    <!-- 查询 -->
     <el-row class="order-query">
      <el-row :gutter="2" style="margin-bottom:15px">
        <el-col :span="6">
          <el-input size="small" placeholder="请输入订单号/提单号" v-model="nblNO"></el-input>
        </el-col>
        <el-col :span="2">
          <el-button
            size="small"
            type="primary"
            @click="queryFrom"
          >
            查询
          </el-button>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <el-row>
        <hot-table
          ref="nblInfoTable"
          :data-source="mainSingleDate"
          :settings="nblInfoTableSettings"
          @rowClick="nblInfoTableRowClick"
        >
          <hot-column :has-tip="true" title="委托人" data="custName" width="150"></hot-column>
          <hot-column :has-tip="true" title="主单订单号" data="orderNo" width="150"></hot-column>
          <hot-column :has-tip="true" title="提单号(MBL.NO)" data="mblNo" width="150"></hot-column>
          <hot-column :has-tip="true" title="船名" data="vesselNameEn" width="150"></hot-column>
          <hot-column :has-tip="true" title="航次" data="voyage" width="150"></hot-column>
          <hot-column :has-tip="true" title="抵港日" data="ata" width="150"
                      date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
          <hot-column :has-tip="true" title="起运港" data="polName" width="150"></hot-column>
          <hot-column :has-tip="true" title="卸货港" data="podName" width="150"></hot-column>
          <hot-column :has-tip="true" title="件数" data="noOfPackage" width="150"></hot-column>
          <hot-column :has-tip="true" title="重量" data="grossWeight" width="150"></hot-column>
          <hot-column :has-tip="true" title="体积" data="cube" width="150"></hot-column>
          <hot-column :has-tip="true" title="箱号" data="ctnNo" width="150"></hot-column>
          <hot-column :has-tip="true" title="箱型尺寸" data="ctnNum" width="150"></hot-column>
          <hot-column :has-tip="true" title="拆箱时间" data="actualUnpackFinishTime" width="150"
                      date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
          <hot-column :has-tip="true" title="进箱时间" data="actualFullInCyTime" width="150"
                      date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
          <hot-column :has-tip="true" title="换单日期" data="blReleaseDate" width="150"
                      date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
          <hot-column :has-tip="true" title="舱单申报" data="mfDeclarationStatus" width="150"
                      dictName="MF_DECLARATION_STATUS"></hot-column>
          <hot-column :has-tip="true" title="分拨申请" data="distributionDeclarationStatus" width="150"
                      dictName="DTB_DECLARATION_STATUS"></hot-column>
        </hot-table>
      </el-row>
    </el-row>
    <!-- tab栏 -->
    <el-row class="tabsContainer tab-module">
      <el-tabs
        type="border-card"
        v-model="activeNames"
        @tab-click="resultTabChange"
      >
        <el-tab-pane label="订单信息" name="1" lazy>
          <el-row>
            <hot-table
              ref="wholeCase"
              :data-source="wholeCaseDatasource"
              :settings="wholeCaseSettings"
              @rowClick="wholeCaseTableRowClick"
            >
<!--              <hot-column :has-tip="true" title="费用查看" width="150">-->
<!--                <column-search-renderer hot-renderer @clickModule="changeEstimatedCostVisible"/>-->
<!--              </hot-column>-->
              <hot-column :has-tip="true" title="分拨订单号" data="orderNo" width="150"></hot-column>
              <hot-column :has-tip="true" title="分拨提单号" data="mblNo" width="150"></hot-column>
              <hot-column :has-tip="true" title="HBL No." data="hblNo" width="150"></hot-column>
              <hot-column :has-tip="true" title="收货人" data="partyDescription" width="150"></hot-column>
              <hot-column :has-tip="true" title="主要品名" data="cargoName" width="150"></hot-column>
              <hot-column :has-tip="true" title="入库时间" data="receivedTime" width="150"
                          date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
              <hot-column :has-tip="true" title="包装类型" data="packageTypeName" width="150"></hot-column>
              <hot-column :has-tip="true" title="件数" data="noOfPackage" width="150"></hot-column>
              <hot-column :has-tip="true" title="重量" data="grossWeight" width="150"></hot-column>
              <hot-column :has-tip="true" title="体积" data="cube" width="150"></hot-column>
              <hot-column :has-tip="true" title="放行状态" data="releaseStatus" width="150"
                          dictName="RELEASE_STATUS"></hot-column>
              <hot-column :has-tip="true" title="放行时间" data="releaseTime" width="150"
                          date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
              <hot-column :has-tip="true" title="是否弃货" data="abandonStatus" width="150"
                          dictName="ABANDOM_STATUS"></hot-column>
              <hot-column :has-tip="true" title="出库时间" data="shipmentTime" width="150"
                          date-format="YYYY-MM-DD HH:mm:ss"></hot-column>
              <hot-column :has-tip="true" title="车牌" data="vehicleCode" width="150"></hot-column>
            </hot-table>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="订单照片" name="2" lazy>
          <el-row class="photo-moudle">
            <el-tabs
              type="border-card"
              v-model="activeName"
              @tab-click="WmOrderPhotoTabChange"
            >
              <el-tab-pane label="整箱" name="1" lazy>
                <el-row>
                  <hot-table
                    ref="WholeBox"
                    :data-source="WmOrderPhotoWholeBoxDatasource"
                    :settings="wholeCaseSettings"
                    @rowClick="photoPreviewrowClick"
                  >
                    <hot-column :has-tip="true" title="查看照片">
                      <column-search-renderer hot-renderer @clickModule="changePreviewPhotoVisible"/>
                    </hot-column>
                    <hot-column :has-tip="true" title="批量下载">
                      <column-download-renderer hot-renderer @clickModule="downPhoto"/>
                    </hot-column>
                    <hot-column :has-tip="true" title="照片数量" data="num"></hot-column>
                    <hot-column :has-tip="true" title="箱号" data="ctnNo"></hot-column>
                    <hot-column :has-tip="true" title="封号" data="sealNo"></hot-column>
                    <hot-column :has-tip="true" title="箱型" data="ctnSizeType"></hot-column>
                    <hot-column :has-tip="true" title="件数" data="noOfPackage"></hot-column>
                    <hot-column :has-tip="true" title="重量" data="grossWeight"></hot-column>
                    <hot-column :has-tip="true" title="体积" data="cube"></hot-column>
                  </hot-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="进仓" name="2" lazy>
                <el-row>
                  <hot-table
                    ref="Warehouse"
                    :data-source="WmOrderPhotoWarehouseDatasource"
                    :settings="wholeCaseSettings"
                    @rowClick="photoPreviewrowClick"
                  >
                    <hot-column :has-tip="true" title="查看照片">
                      <column-search-renderer hot-renderer @clickModule="changePreviewPhotoVisible"/>
                    </hot-column>
                    <hot-column :has-tip="true" title="批量下载">
                      <column-download-renderer hot-renderer @clickModule="downPhoto"/>
                    </hot-column>
                    <hot-column :has-tip="true" title="照片数量" data="num"></hot-column>
                    <hot-column :has-tip="true" title="HBL No." data="hblNo"></hot-column>
                    <hot-column
                      :has-tip="true"
                      title="分单订单号"
                      data="orderNo"
                    >
                    </hot-column>
                    <hot-column :has-tip="true" title="品名" data="cargoName"></hot-column>
                    <hot-column :has-tip="true" title="委托人" data="custName"></hot-column>
                    <hot-column
                      :has-tip="true"
                      title="旅行状态"
                      data="releaseStatus"
                      dictName="RELEASE_STATUS"
                    >
                    </hot-column>
                    <hot-column
                      :has-tip="true"
                      title="是否危险品"
                      data="isHazard"
                      dictName="MD_CODE_YESNO"
                    >
                    </hot-column>
                    <hot-column :has-tip="true" title="件数" data="noOfPackage"></hot-column>
                    <hot-column :has-tip="true" title="重量" data="grossWeight"></hot-column>
                    <hot-column :has-tip="true" title="体积" data="cube"></hot-column>
                  </hot-table>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="出库" name="3" lazy>
                <el-row>
                  <hot-table
                    ref="GoOut"
                    :data-source="WmOrderPhotoGoOutDatasource"
                    :settings="wholeCaseSettings"
                  >
                    <hot-column :has-tip="true" title="操作">
                      <column-search-renderer hot-renderer @clickModule="changePreviewPhotoVisible"/>
                    </hot-column>
                    <hot-column :has-tip="true" title="照片数量" data="num"></hot-column>
                    <hot-column :has-tip="true" title="HBL No." data="hblNo"></hot-column>
                    <hot-column :has-tip="true" title="分单订单号" data="orderNo"></hot-column>
                    <hot-column :has-tip="true" title="品名" data="cargoName"></hot-column>
                    <hot-column :has-tip="true" title="客户名称" data="custName"></hot-column>
                    <hot-column :has-tip="true" title="放行状态" data="releaseStatus" dictName="RELEASE_STATUS">
                    </hot-column>
                    <hot-column :has-tip="true" title="是否危险品" data="isHazard" dictName="MD_CODE_YESNO">
                    </hot-column>
                    <hot-column :has-tip="true" title="件数" data="noOfPackage"></hot-column>
                    <hot-column :has-tip="true" title="重量" data="grossWeight"></hot-column>
                    <hot-column :has-tip="true" title="体积" data="cube"></hot-column>
                  </hot-table>
                </el-row>
              </el-tab-pane>
<!--              <el-tab-pane label="转库" name="4" lazy>-->
<!--                <el-row>-->
<!--                  <hot-table-->
<!--                    ref="Reservoir"-->
<!--                    :data-source="WmOrderPhotoReservoirDatasource"-->
<!--                    :settings="wholeCaseSettings"-->
<!--                  >-->
<!--                    <hot-column :has-tip="true" title="操作">-->
<!--                      <column-search-renderer hot-renderer @clickModule="changePreviewPhotoVisible"/>-->
<!--                    </hot-column>-->
<!--                    <hot-column :has-tip="true" title="照片数量" data="num"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="HBL No." data="hblNo"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="分单订单号" data="orderNo"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="品名" data="cargoName"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="客户名称" data="custName"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="放行状态" data="releaseStatus" dictName="RELEASE_STATUS">-->
<!--                    </hot-column>-->
<!--                    <hot-column :has-tip="true" title="是否危险品" data="isHazard" dictName="MD_CODE_YESNO">-->
<!--                    </hot-column>-->
<!--                    <hot-column :has-tip="true" title="件数" data="noOfPackage"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="重量" data="grossWeight"></hot-column>-->
<!--                    <hot-column :has-tip="true" title="体积" data="cube"></hot-column>-->
<!--                  </hot-table>-->
<!--                </el-row>-->
<!--              </el-tab-pane>-->
            </el-tabs>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </el-row>

    <el-dialog title="提货费用预估" :visible.sync="EstimatedCostVisible">
      <el-form ref="EstimatedCostRef" :rules="EstimatedCostRules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="提货日期:" prop="orderNo">
              <el-date-picker
                v-model="estimateDeliveryTime"
                align="right"
                type="date"
                style="width: 100%"
                size="mini"
                placeholder=""
                default-time="00:00:00"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div>预估提货费用总金额：{{ predictFreightMoney ? predictFreightMoney : "" }}元</div>
        </el-row>
        <el-row type="flex"
                justify="end"
                align="middle"
                :gutter="10"
                class="el-row-margin">
          <el-button
            class="el-button-search"
            type="primary"
            size="small"
            plain
            @click="predictFreight"
          >费用预估
          </el-button
          >
          <el-button
            type="primary"
            size="small"
            plain
            @click="hideEstimatedCostVisible"
          >取消
          </el-button
          >
        </el-row>

      </el-form>
    </el-dialog>
    <preview-photo-box
      :previewPhotoBoxVisible.sync="previewPhotoBoxVisible"
      ref="previewPhotoBoxRef" :fileKey="fileKey"
    />
  </div>
</template>
<script>
import ResizeObserver from "resize-observer-polyfill";
import {
  mainSingleInformation,
  queryFreight,
  getWmOrderPhotos,
  queryMfiLForWeb,
  download,
  predictFreight
} from "@/api/appointment";
import columnSearchRenderer from "@/components/CustomRenderer/columnSearchRenderer";
import previewPhotoBox from "@/views/appointment/previewPhotoBox";
import columnDownloadRenderer from "@/components/CustomRenderer/columnDownloadRenderer";
import {queryDictRows} from "@/api/commonService";

export default {
  name: "ILPWMS",
  components: {
    columnSearchRenderer,
    previewPhotoBox,
    columnDownloadRenderer,
  },
  data() {
    return {
      preview: false,
      predictFreightMoney: "",
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      previewPhotoBoxVisible: false,
      EstimatedCostRules: {},
      estimateDeliveryTime: new Date(),
      EstimatedCostVisible: false,
      isFirstClickPhotos: true,
      isFirstClickPhotosINB: true,
      isFirstClickPhotosINV: true,
      isFirstClickPhotosOUB: true,
      isFirstClickPhotosTB: true,
      WmOrderPhotoWholeBoxDatasource: [],
      WmOrderPhotoWarehouseDatasource: [],
      WmOrderPhotoGoOutDatasource: [],
      WmOrderPhotoReservoirDatasource: [],
      sourceOrder: {},
      nblInfoTableDatasouce: [],
      wholeCaseDatasource: [],
      wholeCaseSettings: {
        height: 240,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      nblInfoTableSettings: {
        height: 180,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      ResizeObserver: null,
      activeNames: "1",
      activeName: "1",
      nblNO: "",
      // num: '',
      // hblNo: '',
      // cargoName: '',
      // custName: '',
      // releaseStatus: '',
      // isHazard: '',
      // noOfPackage: '',
      // grossWeight: '',
      // cube: '',
      //主单
      mainSingleDate: [],
      CurrentWholeCaseRow: {},
      currentPhotoPreview: {},
      fileKey: ''
    };
  },
  async created() {

  },
  mounted() {
    let self = this;
    self.queryReleaseStatus()
    self.queryDangerousStatus()
    self.queryMfStatus()
    self.queryDtbStatus()
    self.queryAbStatus()
    // 监听外层容器div宽度的变化，做表格自适应
    self.resizeObserver = new ResizeObserver((entries) => {
      self.$nextTick(() => {
        self.$refs.nblInfoTable.resizeTo(entries[0].target.clientWidth - 32);
      });
    });
    self.resizeObserver.observe(document.getElementById("ILPWMS"));
  },
  methods: {
    predictFreight() {
      let data = {
        goOrderId: this.CurrentWholeCaseRow.goOrderId,
        bizSource: "pr",
        estimateDeliveryTime: this.estimateDeliveryTime,
        calcType: 'detail'
      }
      predictFreight(data).then(res => {
        if (res.success) {
          this.predictFreightMoney = res.data.amount
        } else {
          // this.predictFreightMoney = ''
        }
      }).catch(err => {
        console.log(err);
      })
    },
    downPhoto() {
      let self = this;
      let url = '/file/batchDownloadByZip';
      if (!this.currentPhotoPreview.fileKeys) return self.$coreMethods.message("warning", "没有照片不需下载！");
      let searchColumns = new URLSearchParams();
      searchColumns.append(
        "keys",
        this.currentPhotoPreview.fileKeys
      );
      searchColumns.append(
        "zipName",
        this.currentPhotoPreview.mblNo + '_' + this.currentPhotoPreview.hblNo + '_' + this.currentPhotoPreview.orderNo
      );
      download(url, searchColumns).then(function (response) {
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(response);
        downloadElement.href = href;
        downloadElement.download = self.currentPhotoPreview.mblNo + '_' + self.currentPhotoPreview.hblNo + '_' + self.currentPhotoPreview.orderNo + '.zip'
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);

      }).catch(res => {

      })
    },
    photoPreviewrowClick(value) {
      this.currentPhotoPreview = value.record;
    },
    changePreviewPhotoVisible() {
      let fileKey = this.currentPhotoPreview.fileKeys ?? "";
      if (fileKey.length > 0) {
        this.fileKey = fileKey;
        this.previewPhotoBoxVisible = true;
      }
    },
    wholeCaseTableRowClick(value) {
      this.CurrentWholeCaseRow = value.record;
    },
    changeEstimatedCostVisible() {
      let self = this
      self.predictFreightMoney = ''
      console.log(this.CurrentWholeCaseRow)
      this.EstimatedCostVisible = true;
    },
    hideEstimatedCostVisible() {
      this.EstimatedCostVisible = false;
    },
    resultTabChange(tab, event) {
      console.log(tab);
      if (tab.name === "1") {
        this.queryMfiLForWeb(this.sourceOrder.sourceOrderId);
      } else {
        if (this.activeName === "1") {
          this.getWmOrderPhotosINB(this.sourceOrder.goOrderId);
        } else if (this.activeName === "2") {
          this.getWmOrderPhotosINV(this.sourceOrder.goOrderId);
        } else if (this.activeName === "3") {
          this.getWmOrderPhotosOUB(this.sourceOrder.goOrderId);
        } else {
          this.getWmOrderPhotosTB(this.sourceOrder.goOrderId);
        }
      }
    },
    WmOrderPhotoTabChange(tab, event) {
      if (tab.name === "1") {
        this.getWmOrderPhotosINB(this.sourceOrder.goOrderId);
      }
      if (tab.name === "2") {
        this.getWmOrderPhotosINV(this.sourceOrder.goOrderId);
      }
      if (tab.name === "3") {
        this.getWmOrderPhotosOUB(this.sourceOrder.goOrderId);
      }
      if (tab.name === "4") {
        this.getWmOrderPhotosTB(this.sourceOrder.goOrderId);
      }
    },
    nblInfoTableRowClick(value) {
      if (this.sourceOrder.sourceOrderId === value.record.sourceOrderId) return;
      this.sourceOrder = value.record;
      if (this.activeNames === "1") {
        this.queryMfiLForWeb(this.sourceOrder.sourceOrderId);
      } else {
        if (this.activeName === "1") {
          this.getWmOrderPhotosINB(this.sourceOrder.goOrderId);
        } else if (this.activeName === "2") {
          this.getWmOrderPhotosINV(this.sourceOrder.goOrderId);
        } else if (this.activeName === "3") {
          this.getWmOrderPhotosOUB(this.sourceOrder.goOrderId);
        } else {
          this.getWmOrderPhotosTB(this.sourceOrder.goOrderId);
        }
      }
      //this.queryFreight(this.sourceOrder.sourceOrderId);
    },
    getWmOrderPhotosINB(id) {
      let self = this;
      this.getWmOrderPhotos(id, "INB")
        .then((res) => {
          if (res.success) {
            self.WmOrderPhotoWholeBoxDatasource = res?.data;

          } else {
            self.WmOrderPhotoWholeBoxDatasource = []
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWmOrderPhotosINV(id) {
      let self = this;
      this.getWmOrderPhotos(id, "INV")
        .then((res) => {
          if (res.success) {
            self.WmOrderPhotoWarehouseDatasource = res?.data;

          } else {
            self.WmOrderPhotoWarehouseDatasource = []
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWmOrderPhotosOUB(id) {
      let self = this;
      this.getWmOrderPhotos(id, "OUB")
        .then((res) => {
          if (res.success) {
            self.WmOrderPhotoGoOutDatasource = res?.data;

          } else {
            self.WmOrderPhotoGoOutDatasource = []
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWmOrderPhotosTB(id) {
      let self = this;
      this.getWmOrderPhotos(id, "TB")
        .then((res) => {
          if (res.success) {
            self.WmOrderPhotoReservoirDatasource = res?.data;

          } else {
            self.WmOrderPhotoReservoirDatasource = []
          }
          this.$forceUpdate();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWmOrderPhotos(id, photoType) {
      let data = {
        mainGoOrderId: id,
        photoType,
      };
      return getWmOrderPhotos({data});
    },
    queryFreight(id) {
      let self = this;
      let data = {
        goOrderId: id,
        pageSize: "10",
        currentPage: "1",
      };
      queryFreight(data)
        .then((res) => {
          if (res.success) {
            self.predictFreightMoney = res.data.amount;
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    queryMfiLForWeb(id) {
      let self = this;
      let data = {
        currentPage: "1",
        pageSize: "1",
        sourceOrderId: id,
      };
      queryMfiLForWeb(data).then(res => {
        if (res.success) {
          self.wholeCaseDatasource = res.records;
        } else {

        }
      }).catch(err => {
        console.log(err)
      })
    },
    queryFrom() {
      let self = this;
      // let searchColumns = new URLSearchParams();
      if (self.nblNO === "") {
        self.$coreMethods.message("failure", "输入为空");
      } else {
        console.log(self.nblNO);
        let nblNO = self.nblNO;
        let searchColumns = {
          orderNo: nblNO,
          currentPage: "1",
          pageSize: "10",
        };
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (userInfo.custId) {
          searchColumns.custId = userInfo.custId;
        }
        mainSingleInformation(searchColumns).then((res) => {
          let self = this;
          // console.log(res)
          //    self.orderNo =res.orderNo
          //    self.voyage =res.voyage
          if (res.success) {
            self.mainSingleDate = res.records;
            console.log(self.mainSingleDate);
          }
        });
      }
    },
    // 获取放行状态数据字典
    queryReleaseStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$RELEASE_STATUS').then(res => {
        let dict = [];
        res.MD_CODE_DICT$RELEASE_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        })
        // self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({RELEASE_STATUS: dict});
      });
    },
    // 获取是否危险品数据字典
    queryDangerousStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$MD_CODE_YESNO').then(res => {
        let dict = [];
        res.MD_CODE_DICT$MD_CODE_YESNO.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        })
        // self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({MD_CODE_YESNO: dict});
      });
    },
    queryMfStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$MF_DECLARATION_STATUS').then(res => {
        let dict = [];
        res.MD_CODE_DICT$MF_DECLARATION_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        })
        // self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({MF_DECLARATION_STATUS: dict});
      });
    },
    queryDtbStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$DTB_DECLARATION_STATUS').then(res => {
        let dict = [];
        res.MD_CODE_DICT$DTB_DECLARATION_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        })
        // self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({DTB_DECLARATION_STATUS: dict});
      });
    },
    queryAbStatus() {
      let self = this
      queryDictRows('MD_CODE_DICT$ABANDOM_STATUS').then(res => {
        let dict = [];
        res.MD_CODE_DICT$ABANDOM_STATUS.forEach(item => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = [];
          dict.push(param);
        })
        // self.ebOrderStatusList = dict;
        // 数据字典
        self.$hotTableUtils.registDict({ABANDOM_STATUS: dict});
      });
    },
  },
  beforeDestroy() {
  },
};
</script>
<style scoped lang="scss">
.order-query{
  margin-bottom:20px;
  background-color:white;
  padding:10px;
  border-radius:10px
}
::v-deep .el-tabs__content{
  min-height: 300px;
}

.photo-moudle ::v-deep .el-tabs__nav-scroll {
  background-color:white !important;
}
</style>
